"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var StyledSwitch_1 = require("./StyledSwitch");
var uid_1 = require("./utilities/uid");
var Switch = function (_a) {
    var checked = _a.checked, onChange = _a.onChange, _b = _a.ariaLabel, ariaLabel = _b === void 0 ? '' : _b, disabled = _a.disabled;
    var id = (0, uid_1.uid)();
    return (react_1.default.createElement(StyledSwitch_1.SwitchBox, { "aria-label": ariaLabel, "data-testid": "switch-box" },
        react_1.default.createElement(StyledSwitch_1.Label, { htmlFor: id },
            react_1.default.createElement(StyledSwitch_1.Input, { role: "switch", "data-testid": "switch", type: "checkbox", id: id, disabled: disabled, checked: checked, onChange: onChange }),
            react_1.default.createElement(StyledSwitch_1.SwitchBackground, { disabled: disabled }),
            react_1.default.createElement(StyledSwitch_1.SwitchHandle, { disabled: disabled }))));
};
exports.default = Switch;
